const LockSvg = (): JSX.Element => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V9H16V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3ZM18 9V7C18 5.4087 17.3679 3.88258 16.2426 2.75736C15.1174 1.63214 13.5913 1 12 1C10.4087 1 8.88258 1.63214 7.75736 2.75736C6.63214 3.88258 6 5.4087 6 7V9H5C3.34315 9 2 10.3431 2 12V20C2 21.6569 3.34315 23 5 23H19C20.6569 23 22 21.6569 22 20V12C22 10.3431 20.6569 9 19 9H18ZM5 11C4.44772 11 4 11.4477 4 12V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V12C20 11.4477 19.5523 11 19 11H5ZM10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16Z'
				fill='#252B39'
			/>
		</svg>
	)
}

export default LockSvg
